import _defineProperty from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import Head from 'next/head';
import { useEffect } from 'react';
import styled from 'styled-components';
import { ToastContextProvider } from '@yoweb/ui/contexts/toast/ToastContext';
import { useUser } from '@poplar/hooks/useUser';
import { APP_EVENT_TOKEN_EXPIRED } from '@poplar/constants/app';
import { getColor, getSpace } from '@yoweb/ui/styles/utils/theme';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/**
 * Primary layout component for pages rendered in a native app webview.
 */
export var AspenLayout = function AspenLayout(_ref) {
  var children = _ref.children,
      bgColor = _ref.bgColor,
      _ref$requireUser = _ref.requireUser,
      requireUser = _ref$requireUser === void 0 ? true : _ref$requireUser;

  var _useUser = useUser(),
      isAuthenticated = _useUser.isAuthenticated;

  useEffect(function () {
    if (!isAuthenticated && requireUser && window.postMessageToApp) {
      window.postMessageToApp(APP_EVENT_TOKEN_EXPIRED);
    }
  }, [isAuthenticated, requireUser]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Head, {
      children: /*#__PURE__*/_jsx("meta", {
        name: "viewport",
        content: "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
      })
    }), /*#__PURE__*/_jsx(AspenLayoutContainer, {
      bgColor: bgColor,
      children: children
    })]
  });
};
var AspenLayoutContainer = styled.div.withConfig({
  componentId: "sc-fn57x1-0"
})(["background-color:", ";min-height:100vh;padding-top:", ";"], function (_ref2) {
  var bgColor = _ref2.bgColor;
  return bgColor ? getColor(bgColor) : getColor('base050');
}, getSpace('normal2'));
export var getAspenLayout = function getAspenLayout(page, props) {
  return /*#__PURE__*/_jsx(ToastContextProvider, {
    defaultPosition: "top-middle",
    children: /*#__PURE__*/_jsx(AspenLayout, _objectSpread(_objectSpread({}, props), {}, {
      children: page
    }))
  });
};
export default AspenLayout;